module.exports = __webpack_public_path__ + "img/ic-acessibilidade-aumentar-texto-ac.8f9ff166.svg";